import React from "react"
import { Modal, ModalOverlay, ModalContent } from "@chakra-ui/react"
import SetStripeBalances from "./SetStripeBalances"
import SelectSegments from "./SelectSegments"
import AddBillingAddress from "./AddBillingAddress"
import { LaunchModalContentType } from "../utils/launchModalUtils"

interface LaunchModalProps {
  isOpen: boolean
  onClose: () => void
  content?: LaunchModalContentType
  onSubmit: (data: any, hasInternationalSegment?: boolean) => void
  companyIds?: { id: number; countryCode: string; name: string }[]
}

export default function LaunchModal({ isOpen, onClose, content, onSubmit, companyIds }: LaunchModalProps) {
  const renderContent = () => {
    switch (content) {
      case LaunchModalContentType.SetStripeBalances:
        return <SetStripeBalances onSubmit={onSubmit} onClose={onClose} />
      case LaunchModalContentType.SelectSegments:
        return <SelectSegments companyIds={companyIds || []} onSubmit={onSubmit} onClose={onClose} />
      case LaunchModalContentType.AddBillingAddress:
        return <AddBillingAddress onSubmit={onSubmit} onClose={onClose} />
      default:
        return <div>Issue loading modals.</div>
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>{renderContent()}</ModalContent>
    </Modal>
  )
}
